import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {FunctieResource} from '../../../../services/resources/functie.resource';
import {OpleidingResource} from '../../../../services/resources/opleiding.resource';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {debounceTime, filter, tap, throttleTime} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {UtilService} from '../../../../services/util/util.service';

@Component({
  selector: 'app-entity-selector',
  templateUrl: './entity-selector.component.html',
  styleUrls: ['./entity-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EntitySelectorComponent implements OnInit, OnDestroy {
  private static readonly defaultOptions = {
    size: 10,
    offset: 0
  };

  @Input()
  public mode: string = 'functie';

  @Input()
  public filters: any = {};

  @Input()
  public placeholder: string;

  @Input()
  public set naam(naam: string) {
    if (naam) {
      this.entityIsSelected = false;
      this.inputFormGroup.controls.naam.setValue(naam);
      this.entityIsSelected = true;
    }
  }

  @Output()
  public entitySelected: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public inputChanged: EventEmitter<any> = new EventEmitter();

  private entityIsSelected: boolean = false;
  public filteredOptions: any[] = [];
  public isMobile: boolean = false;

  public inputFormGroup: UntypedFormGroup = this.formBuilder.group({
    naam: new UntypedFormControl('', [])
  });

  public subscriptions: Subscription[] = [];

  public constructor(
    private functieResource: FunctieResource,
    private opleidingResource: OpleidingResource,
    private formBuilder: UntypedFormBuilder,
    private utilService: UtilService
  ) {
    this.subscriptions.push(
      utilService.getScreenMode$().subscribe((screenMode: string) => {
        this.isMobile = screenMode.includes('MOBILE');
      })
    );
    this.subscriptions.push(
      this.inputFormGroup.controls.naam.valueChanges.subscribe(event => this.inputChanged.emit(event))
    );
  }

  public ngOnInit(): void {
    if (!this.placeholder) {
      this.placeholder = 'Zoek een ' + this.mode;
    }
    this.subscriptions.push(
      this.inputFormGroup.controls.naam.valueChanges
        .pipe(
          tap(() => {
            if (this.entityIsSelected) {
              this.entityIsSelected = false;
              this.entitySelected.emit();
            }
          }),
          filter(query => query.length > 3),
          debounceTime(251),
          tap(query => this.searchResource(query)),
          throttleTime(250)
        )
        .subscribe()
    );
  }

  private searchResource(query: string) {
    if (this.mode === 'functie') {
      const searchOptions = this.createFunctieSearchOptions(query);
      this.functieResource.zoekFuncties(searchOptions).subscribe(response => {
        this.filteredOptions = response.items;
      });
    } else if (this.mode === 'opleiding') {
      const searchOptions = this.createOpleidingSearchOptions(query);
      this.opleidingResource.zoekOpleidingen(searchOptions).subscribe(response => {
        this.filteredOptions = response.items;
      });
    }
  }

  private createFunctieSearchOptions(query: string): any {
    return {
      ...EntitySelectorComponent.defaultOptions,
      ...this.filters,
      query: [query]
    };
  }

  private createOpleidingSearchOptions(query: string): any {
    return {
      ...EntitySelectorComponent.defaultOptions,
      ...this.filters,
      query: [query],
      heeftCompetenties: true,
      soort: ['Beroepsonderwijs', 'Beroepsspecialisatie']
    };
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public select(source: any): void {
    this.entitySelected.emit(source.option.value);
    this.inputFormGroup.controls.naam.setValue(source.option.viewValue);
    this.entityIsSelected = true;
  }
}
